import React, { useEffect } from "react";
import AddIcon from "../../../../Assets/images/add.svg";
import DeleteIcon from "../../../../Assets/images/delete.svg";
import Select from "../../../../Components/FormControl/Select/Select";
import Text from "../../../../Components/FormControl/Text/Text";
import styles from "./orderRecipe.module.scss";

const AddEditRecipeOrderTable = (props) => {
  const productRecipe = props?.recipe || [];

  // If recipe array is empty, render an empty row
  if (!productRecipe.length || productRecipe.length === 0) {
    return (
      <tr>
        <td
          className="text-center col-md-4 col-xs-12 p-0 pr-3"
          style={{ width: "50%" }}
        >
          <Select
            parentClass="text-left"
            value=""
            required={false}
            submitStatus={props.submitStatus}
            onChange={(data) => props.onChange("stockRowMaterial", data, 0)}
            options={props.rowMaterialList}
            disabled={false}
          />
        </td>
        <td className="text-center p-0">
          <Text
            value=""
            required={false}
            submitStatus={props.submitStatus}
            disabled={true}
          />
        </td>
        <td
          className={`text-center p-0`}
          style={{
            width: "15%",
          }}
        >
          <Text
            type="number"
            value=""
            required={true}
            submitStatus={props.submitStatus}
            onChange={(data) => {
              const regex = /^(?:\d+|\d+\.\d{1,2})$/;
              if (regex.test(data.toString())) {
                props.onChange("stockQuantity", data, 0);
              }
              if (!data.toString()) {
                props.onChange("stockQuantity", "", 0);
              }
            }}
            id="quantity"
          />
        </td>
        <td className="text-center p-0" style={{ width: "15%" }}>
          <Text
            value=""
            required={false}
            submitStatus={props.submitStatus}
            disabled={true}
          />
        </td>
        {props.isOrderStatusEditable && (
          <td className="d-flex justify-content-start">
            <div onClick={props.add}>
              <span className={`link cursor-pointer ${styles.iconWrapper}`}>
                <img className={styles.icon} src={AddIcon} alt="" />
              </span>
            </div>
          </td>
        )}
      </tr>
    );
  }

  // Render recipe rows
  return productRecipe.map((val, idx) => {
    return (
      <tr key={val.index || idx}>
        <td
          className="text-center col-md-4 col-xs-12 p-0 pr-3"
          style={{ width: "50%" }}
        >
          <Select
            parentClass="text-left"
            value={Number(val.product_recipe_raw_materials_id)}
            required={false}
            submitStatus={props.submitStatus}
            onChange={(data) => props.onChange("stockRowMaterial", data, idx)}
            options={props.rowMaterialList}
            disabled={!props.isOrderStatusEditable}
          />
        </td>
        <td className="text-center p-0">
          <Text
            value={val.product_recipe_units_name}
            required={false}
            submitStatus={props.submitStatus}
            disabled={true}
          />
        </td>
        <td
          className={`text-center p-0`}
          style={{
            width: "15%",
          }}
        >
          <Text
            type="number"
            value={val.quantity}
            required={true}
            submitStatus={props.submitStatus}
            onChange={(data) => {
              const regex = /^(?:\d+|\d+\.\d{1,2})$/;
              if (regex.test(data.toString())) {
                props.onChange("stockQuantity", data, idx);
              }
              if (!data.toString()) {
                props.onChange("stockQuantity", "", idx);
              }
            }}
            id="quantity"
            disabled={!props.isOrderStatusEditable}
          />
        </td>
        <td
          className="text-center pt-0 pb-0"
          style={{ width: "15%", paddingLeft:"20px"}}
        >
          <Text
            value={`$${val.product_recipe_raw_materials_retail_price || 0}`}
            required={false}
            submitStatus={props.submitStatus}
            disabled={true}
          />
        </td>
        {props.isOrderStatusEditable && (
          <td className="d-flex justify-content-start">
            {/* Show delete button for all rows */}
            <div onClick={() => props.delete(val, val?.id ? val.id : null)}>
              <span>
                <img className={styles.icon} src={DeleteIcon} alt="" />
              </span>
            </div>
            {/* Show add button only for the first row */}
            {idx === 0 && (
              <div onClick={props.add}>
                <span
                  className={`link cursor-pointer ${styles.iconWrapper} ml-3`}
                >
                  <img className={styles.icon} src={AddIcon} alt="" />
                </span>
              </div>
            )}
          </td>
        )}
      </tr>
    );
  });
};
export default AddEditRecipeOrderTable;
